import React, { useEffect, useRef, useState, useReducer } from "react";
import Select from "react-select";
import AutoComplete from "../common/AutoComplete";
import ErrorModal from "../../modal/ErrorModal";
import { addTrailingZeros, formatPrice } from "../helpers/common";


const initialState = {
    orderDetails: [
        {
            ProductID: '',
            ProductName: '',
            Qty: '',
            ClassName: null,
            SizeName: null,
            UnitID: '',
            AgentID: null,
            units: [],
            classList: [],
            sizes: [],
            RRP: 0,
            LastSellPU: 0,
            SellPrice: 0,
            BuyPrice: 0,
            Count: 0
        }
    ]
};

function reducer(state, action) {
    switch (action.type) {
        case 'add_order_item':
            return {
                ...state,
                orderDetails: [
                    ...state.orderDetails,
                    {
                        ProductID: '',
                        ProductCode: '',
                        ProductName: '',
                        Qty: '',
                        ClassName: null,
                        SizeName: null,
                        UnitID: '',
                        AgentID: '',
                        units: [],
                        classList: [],
                        sizes: [],
                        RRP: 0,
                        LastSellPU: 0,
                        SellPrice: 0,
                        BuyPrice: 0,
                        Count: 0
                    }
                ]
            };
        case 'update_order_item':
            const updatedOrderDetails = state.orderDetails.map((item, index) => {
                if (index == action.index) {
                    return { ...item, ...action.data };
                }
                return item;
            });
            return {
                ...state,
                orderDetails: updatedOrderDetails
            };
        case 'delete_order_item':
            return {
                ...state,
                orderDetails: state.orderDetails.filter((_, index) => index != action.index)
            };
        case 'add_order_items':
            return {
                ...state,
                orderDetails: [...action.orderDetails, {
                    ProductID: '',
                    ProductCode: '',
                    ProductName: '',
                    Qty: '',
                    ClassName: null,
                    SizeName: null,
                    UnitID: '',
                    AgentID: '',
                    units: [],
                    classList: [],
                    sizes: [],
                    RRP: 0,
                    LastSellPU: 0,
                    SellPrice: 0,
                    BuyPrice: 0,
                    Count: 0
                }]
            };
        default:
            throw new Error('Unknown action: ' + action.type);
    }
}

const EnterOrderList = ({ orderDetails = [], customerCategory = null, products, agents, units, handleOrderDetailsChange, isCustomerSelect }) => {
    const additionalProducts = [{
        "label": "*",
        "value": "*",
        "product": {
            "ProductID": null,
            "ProductCode": "*",
            "ProductName": "",
            "GST": 0,
            "Current": 1,
            "tblProductDetails": [],
            "tblOrderDetails": []
        }
    },
    {
        "label": "**",
        "value": "**",
        "product": {
            "ProductID": null,
            "ProductCode": "**",
            "ProductName": "",
            "GST": 1,
            "Current": 1,
            "tblProductDetails": [],
            "tblOrderDetails": []
        }
    }]
    products = products.length > 0 ? [...products, ...additionalProducts] : products;
    const [state, dispatch] = useReducer(reducer, initialState);
    const [errors, setErrors] = useState({});
    const [productErrorModal, setProductErrorModal] = useState(false);
    const orderItems = state.orderDetails;
    const productInputRef = useRef(null);
    const agentInputRef = useRef(null);
    const inputTypesRef = useRef([]);
    const [onNewRow, setOnNewRow] = useState(false);

    useEffect(() => {
        const filteredOrderItems = orderItems.filter((item) => {
            if (item.ProductID != '' && item.AgentID != '' && item.Qty != '') {
                return item
            }
        })
        handleOrderDetailsChange(filteredOrderItems);
    }, [orderItems]);


    useEffect(() => {
        if (orderDetails && orderDetails.length > 0) {
            dispatch({ type: 'add_order_items', orderDetails });
        }
    }, [orderDetails]);

    useEffect(() => {
        if (onNewRow && orderItems.length > 1) {
            let productsInputArray = document.getElementsByClassName('product');
            productsInputArray[productsInputArray.length - 1].focus();

        }

        return () => {
            setOnNewRow(false);
        };
    }, [orderItems, onNewRow]);

    const CustomOption = (props) => {
        return (
            <div
                className=""
                style={{
                    background: props.isFocused
                        ? '#01B1E3'
                        : props.isSelected
                            ? 'rgb(54, 179, 126)'
                            : "#fff", color: "gray", zIndex: 1, padding: " 8px 12px", cursor: "default", display: "block", fontSize: "inherit", width: "100%"
                }}
                {...props.innerProps}
                ref={props.innerRef}
            >
                {props.label}
            </div>
        )
    }

    const handleDelete = (index) => {
        if (index === orderItems.length - 1) {
            let productsInputArray = document.getElementsByClassName('product');
            handleInputChange('', index, 'ProductID');
            handleInputChange('', index, 'ProductCode');
            handleInputChange('', index, 'ProductName');
            handleInputChange('', index, 'Qty');
            handleInputChange('', index, 'AgentID');
            handleInputChange([], index, 'units');
            handleInputChange([], index, 'classList');
            handleInputChange([], index, 'sizes');
            productsInputArray[index].focus();
        } else {
            dispatch({ type: 'delete_order_item', index });
        }

    };

    const addNewRow = () => {
        dispatch({ type: 'add_order_item' });
    };

    const handleInputChange = (value, index, field) => {
        dispatch({ type: 'update_order_item', index, data: { [field]: value } });
    };

    const handleProductErrorModal = (value) => {
        setProductErrorModal(value);
        productInputRef.current.focus();
    }

    const checkStarProductCode = (value) => {
        return value == "*" || value == "**" ? true : false
    }

    const checkError = (value, index, field) => {
        let isProductName = ''
        if (field == 'ProductID') {
            isProductName = orderItems[index].ProductName;
            isProductName = checkStarProductCode(orderItems[index].ProductCode) ? isProductName : isProductName || null;
        }
        if (isProductName === null && value > 0) {
            setProductErrorModal(true);
        }
        if (!value || isProductName == null) {
            setErrors((prevData) => ({
                ...prevData,
                [field + index]: true
            }));
        } else {
            setErrors((prevData) => {
                const updatedError = { ...prevData };
                delete updatedError[field + index];
                return updatedError;
            });
        }
    };

    const validateFields = (index) => {
        let fields = ['ProductID', 'ProductName', 'Qty', 'UnitID'];
        let hasErrors = false;
        let isStarProduct = checkStarProductCode(orderItems[index]['ProductCode']);

        fields.forEach((field) => {
            let value = orderItems[index][field];
            if (field == 'ProductName' && !isStarProduct && value === '') {
                setProductErrorModal(true);
            }
            if (field == 'ProductName' && !isStarProduct) {
                field = 'ProductID'
            }
            if (field == 'ProductID' && isStarProduct) {
                value = true
            }
            if (!value) {
                hasErrors = true;
                setErrors((prevData) => ({
                    ...prevData,
                    [field + index]: true
                }));
            } else {
                setErrors((prevData) => {
                    const updatedError = { ...prevData };
                    delete updatedError[field + index];
                    return updatedError;
                });
            }
        });

        return !hasErrors;
    };

    const handleProductAutoComplete = (value, e, index = null) => {
        const selectedObj = products.find(item => item.product.ProductCode == value);
        const targetIndex = e.target.getAttribute('indexId');

        if (!selectedObj) {
            e.preventDefault();
            checkError(value, targetIndex, 'ProductID');
            handleInputChange('', targetIndex, 'ProductID');
            handleInputChange(value, targetIndex, 'ProductCode');
            handleInputChange('', targetIndex, 'ProductName');
            handleInputChange([], targetIndex, 'units');
            handleInputChange([], targetIndex, 'classList');
            handleInputChange([], targetIndex, 'sizes');
            return;
        }

        const selectedProduct = selectedObj.product;
        let unitL = new Set();
        let classL = new Set();
        let sizeL = new Set();

        // Prefill previous finalized order details
        const prevOrder = selectedProduct.tblOrderDetails;
        if (prevOrder) {
            ['ClassName', 'SizeName', 'UnitID', 'AgentID', 'RRP', 'SellPrice', 'BuyPrice', 'Count'].forEach(field =>
                handleInputChange(prevOrder[field], targetIndex, field)
            );
            handleInputChange(prevOrder['SellPrice'], targetIndex, 'LastSellPU')
        }

        selectedProduct.tblProductDetails.forEach((item) => {
            const commonObj = {
                DefAgentID: item.DefAgentID,
                RRP: parseFloat(item.RRP || 0),
                SellPrice: parseFloat(item[`Sell${customerCategory}`] || 0),
                BuyPrice: parseFloat(item.Cost || 0),
                Count: parseInt(item.Wgt || 0)
            };

            if (item.DefUnitID != null) {
                const unit = units.find(unit => unit.value === item.DefUnitID);
                if (unit) unitL.add({ label: unit.label, value: unit.value, ...commonObj });
            }

            if (item.DefClass != null) {
                classL.add({ label: item.DefClass, value: item.DefClass, ...commonObj });
            }

            if (item.DefSize != null) {
                sizeL.add({ label: item.DefSize, value: item.DefSize, ...commonObj });
            }
        });

        // Convert Set to Array
        unitL = Array.from(unitL);
        classL = Array.from(classL);
        sizeL = Array.from(sizeL);

        // Allow all units when product is StarCode
        if (checkStarProductCode(selectedProduct.ProductCode)) {
            unitL = units;
        }

        // Handle input changes in bulk
        const fieldsToUpdate = {
            units: unitL,
            classList: classL,
            sizes: sizeL,
            ProductID: selectedProduct.ProductID,
            ProductCode: selectedProduct.ProductCode,
            ProductName: selectedProduct.ProductName,
        };

        Object.entries(fieldsToUpdate).forEach(([key, val]) => handleInputChange(val, targetIndex, key));

        // Prefill values
        if (!prevOrder)
            handlePrefilledValues(targetIndex, unitL, classL, sizeL);

        // Remove error if present
        if (errors[`ProductID${targetIndex}`]) {
            setErrors(prevData => {
                const updatedError = { ...prevData };
                delete updatedError[`ProductID${targetIndex}`];
                return updatedError;
            });
        }

        // Focus on next input if index exists
        if (index !== null) {
            inputTypesRef[`${index}0`]?.focus();
        }
    };


    //Check if same Product is exist with same Agent
    const checkExistingProduct = (agentValue, targetIndex) => {
        let sameIndex = orderItems.findIndex(item => item.ProductID == orderItems[targetIndex].ProductID && item.AgentID == agentValue);
        return sameIndex != targetIndex ? sameIndex : -1;
    }

    const handlePrefilledValues = (targetIndex, units, classList, sizeList) => {
        const prefillFields = (list, fieldName) => {
            if (list?.length === 1) {
                const { value, DefAgentID, SellPrice, RRP, BuyPrice, Count } = list[0];
                const fieldsToUpdate = {
                    [fieldName]: value,
                    AgentID: DefAgentID,
                    SellPrice,
                    RRP,
                    BuyPrice,
                    Count
                };

                Object.entries(fieldsToUpdate).forEach(([key, val]) => handleInputChange(val, targetIndex, key));
            }
        };

        prefillFields(units, 'UnitID');
        prefillFields(classList, 'ClassName');
        prefillFields(sizeList, 'SizeName');
    };


    const handleAgentAutoComplete = (value, e) => {
        e.preventDefault();
        let selectedObj = agents.find(item => item.label == value)
        const targetIndex = parseInt(e.target.getAttribute('indexId'));
        if (selectedObj) {
            checkError(selectedObj.value, targetIndex, 'AgentID')
            const currentOrder = orderItems[targetIndex];
            handleInputChange(selectedObj.value, targetIndex, 'AgentID');
            // const isSameProduct = checkExistingProduct(selectedObj.value, targetIndex);

            // if (isSameProduct !== -1) {
            //     const existingOrder = orderItems[isSameProduct];

            //     handleDelete(targetIndex);
            //     const updatedQty = parseInt(existingOrder.Qty) + parseInt(currentOrder.Qty);
            //     handleInputChange(updatedQty, isSameProduct, 'Qty');
            //     e.preventDefault();
            //     productInputRef.current.focus();
            // }
            if (currentOrder.UnitID == '') {
                checkError('', targetIndex, 'UnitID')
            } else {
                checkError(currentOrder.UnitID, targetIndex, 'UnitID')
            }

        } else {
            handleInputChange('', targetIndex, 'AgentID');
            checkError('', targetIndex, 'AgentID')
            e.preventDefault()
        }

        if (targetIndex == orderItems.length - 1 && validateFields(targetIndex)) {
            addNewRow();
            setOnNewRow(true);
        } else if (targetIndex == orderItems.length - 1) {
            e.preventDefault();
        } else {
            let productsInputArray = document.getElementsByClassName('product');
            productsInputArray[targetIndex + 1].focus();

        }
    }

    const handleKeyEvent = (e) => {
        const keyCode = e.keyCode;
        const target = e.currentTarget;
        let productsInputArray = document.getElementsByClassName('product');
        let agentsInputArray = document.getElementsByClassName('agent');
        if (target.classList.contains("autocomplete-input")) {
            const currentId = target.id.split('-')[0];
            const index = parseInt(target.id.split('-')[1]);

            if (currentId === 'product' && keyCode === 13) {
                handleProductAutoComplete(e.target.value, e, index);
            } else if (currentId === 'product' && keyCode === 39) {
                inputTypesRef[`${index}0`].focus();
            } else if (currentId === 'agent' && keyCode === 37) {
                inputTypesRef[`${index}3`].focus();
            } else if (currentId === 'agent' && keyCode === 13) {
                handleAgentAutoComplete(e.target.value, e);
            }
            else if (currentId === 'product' && keyCode === 38) {
                productsInputArray[index - 1].focus();
            }
            else if (currentId === 'product' && keyCode === 40) {
                productsInputArray[index + 1].focus();
            }
            else if (currentId === 'agent' && keyCode === 38) {
                agentsInputArray[index - 1].focus();
            }
            else if (currentId === 'agent' && keyCode === 40) {
                agentsInputArray[index + 1].focus();
            }
        } else {
            let currentIndex = e.currentTarget.id
            let firstCurrentIndex = parseInt(currentIndex.slice(0, currentIndex.length - 1));
            let lastCurrentIndex = parseInt(currentIndex.slice(currentIndex.length - 1));
            if (keyCode === 39 || keyCode === 13) {
                lastCurrentIndex === 3 ? agentsInputArray[firstCurrentIndex].focus() : inputTypesRef[`${firstCurrentIndex}${lastCurrentIndex + 1}`].focus();
            } else if (keyCode === 37) {
                lastCurrentIndex === 0 ? productsInputArray[firstCurrentIndex].focus() : inputTypesRef[`${firstCurrentIndex}${lastCurrentIndex - 1}`].focus();
            }
        }
    };

    return (
        <>
            {/* Product not found error modal */}
            {productErrorModal && <ErrorModal modal={productErrorModal} setModal={handleProductErrorModal} errorMessage="Product Code not found !" />}
            {orderItems.map((el, i) => {
                return (
                    <React.Fragment key={i}>
                        <tr key={i}>
                            <td scope="col" className="width-lg-8">
                                <AutoComplete
                                    id={`product-${i}`}
                                    indexId={i}
                                    key={`product-${i}`}
                                    className="product"
                                    isError={errors[`ProductID` + i]}
                                    inputRef={productInputRef}
                                    text={el.ProductCode}
                                    options={products}
                                    placeholder={'Select Code'}
                                    onTab={handleProductAutoComplete}
                                    //onBlur={(e) => checkError(e.target.value, i, 'ProductID')}
                                    onKeyDown={handleKeyEvent}
                                    disabled={isCustomerSelect}
                                />
                            </td>
                            <td scope="col" className="width-lg-42">
                                <input
                                    type="text"
                                    className={`form-control input-sm input-width-375 ${errors[`ProductName` + i] ? "is-invalid" : ''}`}
                                    placeholder="Product Name"
                                    disabled={!checkStarProductCode(el.ProductCode)}
                                    value={el.ProductName}
                                    name="ProductName"
                                    onChange={(e) => {
                                        handleInputChange(e.target.value, i, 'ProductName')
                                    }}
                                    onBlur={(e) => checkError(e.target.value, i, 'ProductName')}
                                />
                            </td>
                            <td scope="col" className="width-lg-10">
                                <input
                                    id={`${i}0`}
                                    type="number"
                                    value={el.Qty}
                                    className={`form-control input-sm text-end input-width-172 ${errors[`Qty` + i] ? "is-invalid" : ''}`}
                                    placeholder="Qty"
                                    name="Qty"
                                    autoComplete="off"
                                    onBlur={(e) => {
                                        checkError(e.target.value, i, 'Qty')
                                        handleInputChange(addTrailingZeros(e.target.value), i, 'Qty')
                                    }}
                                    onChange={(e) => {
                                        if (e.target.value >= 0)
                                            handleInputChange(formatPrice(e.target.value), i, 'Qty')
                                    }}
                                    ref={el => inputTypesRef[`${i}0`] = el}
                                    onKeyDown={handleKeyEvent}
                                    disabled={isCustomerSelect}
                                />
                            </td>
                            <td scope="col" className="width-lg-10">
                                <Select
                                    id={`${i}1`}
                                    className={`input-sm ${errors[`UnitID` + i] ? "react-select-invalid" : ''}`}
                                    defaultValue={"Select Units"}
                                    value={el.units.find(unit => unit.value == el.UnitID) || ''}
                                    options={el.units}
                                    placeholder="Select Units"
                                    onChange={(e) => {
                                        handleInputChange(parseInt(e.value), i, "UnitID")
                                        let selectedProductDetails = products.find(item => item.product.ProductCode == el.ProductCode)?.product?.tblProductDetails
                                        let selectedClassObj = selectedProductDetails.find(item => item.DefUnitID === e.value);
                                        if (selectedClassObj) {
                                            handleInputChange(selectedClassObj.DefClass, i, "ClassName");
                                            handleInputChange(selectedClassObj.DefSize, i, "SizeName")
                                            handleInputChange(selectedClassObj.DefAgentID, i, "AgentID")
                                            handleInputChange(selectedClassObj[`Sell${customerCategory}`] || 0, i, "SellPrice")
                                            handleInputChange(selectedClassObj.RRP, i, "RRP")
                                            handleInputChange(selectedClassObj.Cost, i, "BuyPrice")
                                            handleInputChange(selectedClassObj.Wgt, i, "Count")
                                        }
                                    }}
                                    components={{ Option: CustomOption }}
                                    isSearchable
                                    ref={el => inputTypesRef[`${i}1`] = el}
                                    onKeyDown={handleKeyEvent}
                                    menuPortalTarget={document.body}
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                ></Select>
                            </td>
                            <td scope="col" className="width-lg-10">
                                <Select
                                    id={`${i}2`}
                                    className={`input-sm`}
                                    defaultValue={"Select Class"}
                                    value={el.classList.find(classList => classList.value == el.ClassName) || ''}
                                    options={el.classList}
                                    placeholder="Select Class"
                                    onChange={(e) => {
                                        handleInputChange(e.value, i, "ClassName");
                                        let selectedProductDetails = products.find(item => item.product.ProductCode == el.ProductCode)?.product?.tblProductDetails
                                        let selectedClassObj = selectedProductDetails.find(item => item.DefClass === e.value);
                                        if (selectedClassObj) {
                                            handleInputChange(selectedClassObj.DefSize, i, "SizeName")
                                            handleInputChange(selectedClassObj.DefAgentID, i, "AgentID")
                                            handleInputChange(selectedClassObj[`Sell${customerCategory}`] || 0, i, "SellPrice")
                                            handleInputChange(selectedClassObj.RRP, i, "RRP")
                                            handleInputChange(selectedClassObj.Cost, i, "BuyPrice")
                                            handleInputChange(selectedClassObj.Wgt, i, "Count")
                                        }
                                    }}
                                    components={{ Option: CustomOption }}
                                    isSearchable
                                    ref={el => inputTypesRef[`${i}2`] = el}
                                    onKeyDown={handleKeyEvent}
                                    menuPortalTarget={document.body}
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                ></Select>
                            </td>
                            <td scope="col" className="width-lg-10">
                                <Select
                                    id={`${i}3`}
                                    className={`input-sm`}
                                    defaultValue={"Select Size"}
                                    value={el.sizes.find(size => size.value == el.SizeName) || ''}
                                    options={el.sizes}
                                    placeholder="Select Size"
                                    onChange={(e) => {
                                        handleInputChange(e.value, i, "SizeName");
                                        let selectedProductDetails = products.find(item => item.product.ProductCode == el.ProductCode)?.product?.tblProductDetails
                                        let selectedClassObj = selectedProductDetails.find(item => item.DefSize === e.value);
                                        if (selectedClassObj) {
                                            handleInputChange(selectedClassObj.DefAgentID, i, "AgentID")
                                            handleInputChange(selectedClassObj[`Sell${customerCategory}`] || 0, i, "SellPrice")
                                            handleInputChange(selectedClassObj.RRP, i, "RRP")
                                            handleInputChange(selectedClassObj.Cost, i, "BuyPrice")
                                            handleInputChange(selectedClassObj.Wgt, i, "Count")
                                        }
                                    }}
                                    components={{ Option: CustomOption }}
                                    isSearchable
                                    ref={el => inputTypesRef[`${i}3`] = el}
                                    onKeyDown={handleKeyEvent}
                                    menuPortalTarget={document.body}
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                ></Select>
                            </td>

                            <td className="d-flex align-items-center">
                                <AutoComplete id={`agent-${i}`} indexId={i} key={`agent-${i}`} className="agent" isCaseSentive={true} inputRef={agentInputRef} isError={errors['AgentID' + i]} text={agents.find(item => item.value == el.AgentID)?.label} options={agents} placeholder={'Select Agent'} onTab={handleAgentAutoComplete} onBlur={(e) => checkError(e.target.value, i, 'AgentID')} onKeyDown={handleKeyEvent} disabled={isCustomerSelect} />
                                <div className="d-inline-flex align-items-center justify-content-end flex-grow-1">
                                    <div
                                        style={{
                                            cursor: "pointer",
                                        }}
                                        onClick={() => handleDelete(i)}
                                        className="text-decoration-none "
                                    >
                                        <i className="icon icon-delete ms-3 text-danger fw-bold"></i>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </React.Fragment>
                );
            })}
            {orderItems.length == 1 && (orderItems[0].ProductID == '' || orderItems[0].Qty == '' || orderItems[0].UnitID == '' || orderItems[0].AgentID == '') && (
                <div className="text-center mt-5 text-lite empty-card">
                    Orders cart is empty
                </div>
            )}
        </>
    )
}

export default EnterOrderList
